import React, { useEffect } from 'react';
import pic from '../../images/fahim/black.jpg';
import pic2 from '../../images/fahim/pic2.png';
import pic3 from '../../images/fahim/Jersey.jpg';
import { BsFacebook, BsLinkedin, BsInstagram, BsGithub } from 'react-icons/bs';
import AIUB from '../../images/education/aiub.png';
import College from '../../images/education/college.jpeg';
import School from '../../images/education/dzs.jpeg';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Lottie from 'lottie-react';
import notifyMe from '../../images/lottie-animation/notify.json';
import useTitle from '../../Hooks/useTitle';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';






const AboutMe = () => {


    useTitle('About Myself | Portfolio');
    const { pathname } = useLocation();

    useEffect(() => {
        AOS.init({
            duration: 2000
        })
    }, [])



    const { language } = useLanguage();




    const translations = {
        english: 'Hello! I am Fahim Faysal from Dinajpur, Bangladesh. I have completed my Bachelor’s degree from American International University, Bangladesh (AIUB) in Computer Science and Engineering with an academic CGPA of 3.94 out of 4.00. <br /> I am very fond of traveling, riding bikes, eating different foods and roaming around with my friends. Besides I play cricket, football, badminton etc. I can fluently speak Bangla and English and my writing skills in both the languages are quite good. I got scholarship in SSC exam and my academic results were always been very good since my school days to my graduation. <br /> I am an honest person in every aspect of my life. I have a good leadership quality in working with people and I can adopt things very quickly. Besides I have decision making abilities in critical situations and I like to do creative things. ',
        bangla: 'হ্যালো! আমি ফাহিম ফয়সাল। আমি আমেরিকান ইন্টারন্যাশনাল ইউনিভার্সিটি, বাংলাদেশ (AIUB) থেকে কম্পিউটার সায়েন্স অ্যান্ড ইঞ্জিনিয়ারিং-এ 4.00-এর মধ্যে 3.94 অ্যাকাডেমিক CGPA সহ আমার স্নাতক ডিগ্রি সম্পন্ন করেছি। <br /> আমি ভ্রমণ, বাইক চালানো, বিভিন্ন খাবার খেতে এবং আমার বন্ধুদের সাথে ঘোরাঘুরি করতে খুব পছন্দ করি। আমি ক্রিকেট, ফুটবল, ব্যাডমিন্টন ইত্যাদি খেলার পাশাপাশি সাবলীলভাবে বাংলা ও ইংরেজি বলতে পারি এবং উভয় ভাষায় আমার লেখার দক্ষতা বেশ ভালো। আমি এসএসসি পরীক্ষায় বৃত্তি পেয়েছি এবং আমার স্কুল জীবন থেকে স্নাতক পর্যন্ত আমার একাডেমিক ফলাফল সবসময়ই খুব ভাল ছিল। <br /> আমি আমার জীবনের প্রতিটি ক্ষেত্রে একজন সৎ ব্যক্তি। মানুষের সাথে কাজ করার ক্ষেত্রে আমার একটি ভাল নেতৃত্বের গুণ রয়েছে এবং আমি খুব দ্রুত জিনিসগুলি গ্রহণ করতে পারি। এছাড়াও আমার সংকটময় পরিস্থিতিতে সিদ্ধান্ত নেওয়ার ক্ষমতা রয়েছে এবং আমি সৃজনশীল জিনিসগুলি করতে পছন্দ করি।',
    };
    const paragraphs = translations[language].split('<br />').map((paragraph, index) => (
        <p className='text-lg mb-3' key={index}>{paragraph}</p>
    ));









    return (
        <div className={`my-8 ${pathname.includes('aboutMe') ? 'sm:mt-10 md:mt-36 mt-32' : 'sm:mt-4 md:mt-0 mt-4'}`}>

            <div className='grid lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 grid-cols-1'>
                <div className='mx-4 sm:mx-4 md:mx-auto lg:mx-auto  animation' data-aos='zoom-in'>
                    <img className='w-[450px] h-[550px] rounded-md ' src={pic3} alt="FahimImage" />
                </div>

                <div className='lg:mr-10 md:mr-0 sm:mr-0 mr-0'>



                    {
                        language === 'english' ?
                            <h1 className='text-center uppercase font-mono text-4xl  lg:mt-0 md:mt-6 sm:mt-6 mt-6 lg:mb-4 md:mb-4 sm:mb-4 mb-2'>About<span className='text-rose-600 font-semibold text-6xl'>Me</span></h1>
                            :
                            <h1 className='text-center uppercase font-mono text-4xl  lg:mt-0 md:mt-6 sm:mt-10 mt-10 lg:mb-4 md:mb-4 sm:mb-6 mb-6'>আমার<span className='text-rose-600 font-semibold text-5xl'> সম্পর্কে</span></h1>
                    }



                    {/* <div>
                        <p className='text-lg text-justify lg:mx-0 md:mx-12 sm:mx-4 mx-6'> Hello! I am <span className='text-4xl font-semibold text-amber-500'>Fahim Faysal</span>  from Dinajpur, Bangladesh. I have completed my Bachelor’s degree from American International University, Bangladesh (AIUB) in Computer Science and Engineering with an academic CGPA of 3.94 out of 4.00.</p> <br />
                        <p className='text-lg text-justify lg:mx-0 md:mx-12 sm:mx-4 mx-6'> I am very fond of travelling, riding bikes, eating different foods and roaming around with my friends. Besides I play cricket, football, badminton etc. I can fluently speak Bangla and English and my writing skills in both the languages are quite good. I got scholarship in SSC exam and my academic results were always been very good since my school days to my graduation. </p> <br />
                        <p className='text-lg text-justify lg:mx-0 md:mx-12 sm:mx-4 mx-6'> I am an honest person in every aspect of my life. I have a good leadership quality in working with people and I can adopt things very quickly. Besides I have decision making abilities in critical situations and I like to do creative things.</p> <br />
                    </div> */}

                    {/* <p className='text-lg text-justify lg:mx-0 md:mx-12 sm:mx-4 mx-6'>{paragraphs}</p> */}

                    {
                        language === 'english' ?
                            <>
                                <div>
                                    <p className='text-lg text-justify lg:mx-0 md:mx-12 sm:mx-4 mx-6'> Hello! I am <span className='text-4xl font-semibold text-amber-500'>Fahim Faysal</span>  from Dinajpur, Bangladesh. I have completed my Bachelor’s degree from American International University, Bangladesh (AIUB) in Computer Science and Engineering with an academic CGPA of 3.94 out of 4.00.</p> <br />
                                    <p className='text-lg text-justify lg:mx-0 md:mx-12 sm:mx-4 mx-6'> I am very fond of travelling, riding bikes, eating different foods and roaming around with my friends. Besides I play cricket, football, badminton etc. I can fluently speak Bangla and English and my writing skills in both the languages are quite good. I got scholarship in SSC exam and my academic results were always been very good since my school days to my graduation. </p> <br />
                                    <p className='text-lg text-justify lg:mx-0 md:mx-12 sm:mx-4 mx-6'> I am an honest person in every aspect of my life. I have a good leadership quality in working with people and I can adopt things very quickly. Besides I have decision making abilities in critical situations and I like to do creative things.</p> <br />
                                </div>
                            </>
                            :
                            <>
                                {/* <p className='text-lg text-justify lg:mx-0 md:mx-12 sm:mx-4 mx-6'>{paragraphs}</p> */}
                                <div>
                                    <p className='text-lg text-justify lg:mx-0 md:mx-12 sm:mx-4 mx-6'> হ্যালো! আমি <span className='text-3xl font-semibold text-amber-500'>ফাহিম ফয়সাল,</span>   আমি আমেরিকান ইন্টারন্যাশনাল ইউনিভার্সিটি, বাংলাদেশ (এ আই ইউ বি) থেকে কম্পিউটার সায়েন্স অ্যান্ড ইঞ্জিনিয়ারিং-এ ৪.০০ এর মধ্যে ৩.৯৪ অ্যাকাডেমিক সিজিপিএ সহ আমার স্নাতক ডিগ্রি সম্পন্ন করেছি</p> <br />
                                    <p className='text-lg text-justify lg:mx-0 md:mx-12 sm:mx-4 mx-6'> আমি ভ্রমণ, বাইক চালানো, বিভিন্ন খাবার খেতে এবং আমার বন্ধুদের সাথে ঘোরাঘুরি করতে খুব পছন্দ করি। আমি ক্রিকেট, ফুটবল, ব্যাডমিন্টন ইত্যাদি খেলার পাশাপাশি সাবলীলভাবে বাংলা ও ইংরেজি বলতে পারি এবং উভয় ভাষায় আমার লেখার দক্ষতা বেশ ভালো। আমি এসএসসি পরীক্ষায় বৃত্তি পেয়েছি এবং আমার স্কুল জীবন থেকে স্নাতক পর্যন্ত আমার একাডেমিক ফলাফল সবসময়ই খুব ভাল ছিল।</p> <br />
                                    <p className='text-lg text-justify lg:mx-0 md:mx-12 sm:mx-4 mx-6'>
                                        আমি আমার জীবনের প্রতিটি ক্ষেত্রে একজন সৎ ব্যক্তি। মানুষের সাথে কাজ করার ক্ষেত্রে আমার একটি ভাল নেতৃত্বের গুণ রয়েছে এবং আমি খুব দ্রুত জিনিসগুলি গ্রহণ করতে পারি। এছাড়াও আমার সংকটময় পরিস্থিতিতে সিদ্ধান্ত নেওয়ার ক্ষমতা রয়েছে এবং আমি সৃজনশীল জিনিসগুলি করতে পছন্দ করি।</p> <br />
                                </div>
                            </>
                    }












                    <div className='flex justify-center items-center gap-x-10 md:flex-row flex-col'>

                        <div className='w-28 -mr-12' >
                            <Lottie
                                animationData={notifyMe}
                                loop={true}

                            ></Lottie>
                        </div>

                        {
                            language === 'english' ?
                                <h3 className='text-2xl'> <span className='text-rose-600 font-semibold'>Connect</span> With Me </h3>
                                :
                                <h3 className='text-2xl'> <span className='text-rose-600 font-semibold'>যোগাযোগ</span> করুন</h3>
                        }

                        <div className='lg:my-0 md:my-0 sm:my-3 my-3'>
                            <a href='https://github.com/Fahimsakib1?tab=repositories' target='blank' className='tooltip mr-4' data-tip='GitHub'>
                                <BsGithub className='text-3xl  hover:bg-black hover:text-white rounded-lg transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsGithub>
                            </a>

                            <a href='https://www.linkedin.com/in/fahim-faysal/' target='blank' className='tooltip mr-4' data-tip='LinkedIn'>
                                <BsLinkedin className='text-3xl  hover:text-blue-700 ransition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsLinkedin>
                            </a>

                            <a href='https://www.instagram.com/i_fahiim/' target='blank' className='tooltip mr-4' data-tip='Instagram'>
                                <BsInstagram className='text-3xl  hover:text-rose-500 ransition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsInstagram>
                            </a>

                            <a href='https://www.facebook.com/fahim.sakib.5' target='blank' className='tooltip mr-4' data-tip='Facebook'>
                                <BsFacebook className='text-3xl  hover:text-blue-500 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsFacebook>
                            </a>
                        </div>
                    </div>
                </div>
            </div>


            <div className='mt-40'>

                <div className="divider text-rose-600 md:text-5xl text-4xl text-center font-mono font-semibold uppercase w-3/4 mx-auto mb-12">{language === 'english' ? 'Education' : 'শিক্ষা বৃত্তান্ত'}</div>

                <div>
                    <div className='flex justify-center lg:flex-row flex-col items-center gap-x-16 animation' data-aos='fade-left'>
                        <div className="avatar">
                            <div className="w-24 sm:w-28 md:w-36 rounded-full md:mt-6 lg:mt-0 sm:mt-0 mt-0 lg:mb-0 md:mb-4 sm:mb-3 mb-3 animation" data-aos='zoom-in'>
                                <img src={AIUB} alt='AIUB' />
                            </div>
                        </div>
                        <div>
                            <h1 className='text-xl sm:text-xl md:text-2xl lg:text-2xl text-center'>{language === 'english' ? 'American International University Bangladesh (AIUB)' : 'আমেরিকান ইন্টারন্যাশনাল ইউনিভার্সিটি বাংলাদেশ (এ আই ইউ বি)'}</h1>
                            <p className='text-center text-md'>{language === 'english' ? 'Bachelor of Science in Computer Science and Engineering (CSE)' : 'কম্পিউটার সায়েন্স অ্যান্ড ইঞ্জিনিয়ারিং (সিএসই) এ ব্যাচেলর অফ সায়েন্স'} </p>
                            <p className='text-center text-md text-amber-500 font-semibold'>{language === 'english' ? 'CGPA: 3.94 Out of 4.00' : 'সিজিপিএ: ৪.০০ এর মধ্যে ৩.৯৪'} </p>
                            <p className='text-center text-lg text-cyan-500 font-semibold'>{language === 'english' ? 'Academic Year: 2017-2021' : 'শিক্ষাবর্ষ: ২০১৭-২০২১'} </p>
                        </div>
                    </div>
                </div>

                <div className="divider w-3/4 mx-auto"></div>

                <div>
                    <div className='flex justify-center lg:flex-row flex-col-reverse items-center gap-x-16 animation' data-aos='fade-right'>
                        <div>
                            <h1 className='text-xl sm:text-xl md:text-2xl lg:text-2xl text-center'>{language === 'english' ? 'Dinajpur Government College, Dinajpur' : 'দিনাজপুর সরকারি কলেজ, দিনাজপুর'}</h1>
                            <p className='text-center text-lg'>{language === 'english' ? 'Science, HSC' : ' বিজ্ঞান, এইচএসসি'}</p>
                            <p className='text-center text-md text-amber-500 font-semibold'>{language === 'english' ? 'GPA: 5.00 Out of 5.00' : 'জিপিএ: ৫.০০ এর মধ্যে ৫.০০'} </p>
                            <p className='text-center text-lg text-cyan-500 font-semibold'>{language === 'english' ? 'Academic Year: 2013-2015' : 'শিক্ষাবর্ষ: ২০১৩-২০১৫'}</p>
                        </div>
                        <div className="avatar  lg:mb-0 md:mb-4 sm:mb-3 mb-3">
                            <div className="w-24 sm:w-28 md:w-36 rounded-full md:mt-6 lg:mt-0 sm:mt-0 mt-0 animation" data-aos='zoom-in'>
                                <img src={College} alt='College' />
                            </div>
                        </div>
                    </div>
                </div>


                <div className="divider w-3/4 mx-auto"></div>

                <div>
                    <div className='flex justify-center lg:flex-row flex-col items-center gap-x-16 animation' data-aos='fade-left'>
                        <div className="avatar md:mb-6 lg:mb-0">
                            <div className="w-24 sm:w-28 md:w-36 rounded-full md:mt-6 lg:mt-0 sm:mt-0 mt-0 lg:mb-0 md:mb-4 sm:mb-3 mb-3 animation" data-aos='zoom-in'>
                                <img src={School} alt='College' />
                            </div>
                        </div>

                        <div>
                            <h1 className='text-xl sm:text-xl md:text-2xl lg:text-2xl text-center'>{language === 'english' ? 'Dinajpur Zilla School, Dinajpur' : 'দিনাজপুর জিলা স্কুল, দিনাজপুর'}</h1>
                            <p className='text-center text-lg'>{language === 'english' ? 'Science, SSC' : 'বিজ্ঞান, এস.এস.সি'} </p>
                            <p className='text-center text-md text-amber-500 font-semibold'>{language === 'english' ? 'GPA: 5.00 Out of 5.00' : 'জিপিএ: ৫.০০ এর মধ্যে ৫.০০'}</p>
                            <p className='text-center text-lg text-cyan-500 font-semibold'>{language === 'english' ? 'Academic Year: 2005-2012' : 'শিক্ষাবর্ষ: ২০০৫-২০১২'}</p>
                        </div>
                    </div>

                </div>

                <div className="divider w-3/4 mx-auto"></div>

            </div>
        </div>
    );
};

export default AboutMe;